import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const VariableIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M4.91276 3.91912C5.42885 3.40124 6.17108 3 7 3C7.55228 3 8 3.44772 8 4C8 4.55228 7.55228 5 7 5C6.81851 5 6.56074 5.09876 6.32943 5.33088C6.09765 5.56347 6 5.82204 6 6V11C6 11.2652 5.89464 11.5196 5.70711 11.7071L5.41421 12L5.70711 12.2929C5.89464 12.4804 6 12.7348 6 13V18C6 18.178 6.09765 18.4365 6.32943 18.6691C6.56074 18.9012 6.81851 19 7 19C7.55228 19 8 19.4477 8 20C8 20.5523 7.55228 21 7 21C6.17108 21 5.42885 20.5988 4.91276 20.0809C4.39715 19.5635 4 18.822 4 18V13.4142L3.29289 12.7071C2.90237 12.3166 2.90237 11.6834 3.29289 11.2929L4 10.5858V6C4 5.17796 4.39715 4.43653 4.91276 3.91912ZM16 4C16 3.44772 16.4477 3 17 3C17.6486 3 18.4043 3.1602 19.0152 3.66928C19.6582 4.20509 20 5.00952 20 6V10.5858L20.7071 11.2929C21.0976 11.6834 21.0976 12.3166 20.7071 12.7071L20 13.4142V18C20 19.8968 18.4767 21 17 21C16.4477 21 16 20.5523 16 20C16 19.4477 16.4477 19 17 19C17.5425 19 18 18.6292 18 18V13C18 12.7348 18.1054 12.4804 18.2929 12.2929L18.5858 12L18.2929 11.7071C18.1054 11.5196 18 11.2652 18 11V6C18 5.49048 17.8418 5.29491 17.7348 5.20572C17.5957 5.0898 17.3514 5 17 5C16.4477 5 16 4.55228 16 4ZM8 9C8 8.44772 8.44772 8 9 8H9.11943C9.727 8 10.3016 8.27618 10.6812 8.7506L12.0001 10.3992L13.319 8.7506C13.6985 8.27618 14.2732 8 14.8807 8H15C15.5523 8 16 8.44772 16 9C16 9.55228 15.5523 10 15 10H14.8807L13.2807 12L14.8807 14H15C15.5523 14 16 14.4477 16 15C16 15.5523 15.5523 16 15 16H14.8807C14.2732 16 13.6985 15.7238 13.319 15.2494L12.0001 13.6008L10.6812 15.2494C10.3016 15.7238 9.727 16 9.11943 16H9C8.44772 16 8 15.5523 8 15C8 14.4477 8.44772 14 9 14H9.11943L10.7194 12L9.11943 10H9C8.44772 10 8 9.55228 8 9Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

VariableIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(VariableIcon);
